<template lang="pug">
.my-card-template
  .my-card-container(:class="{ 'one-cent-ride': !!singlePayAmount }")
    .app-use-logo(v-if="isApp")
      .app-use-logo-text APP专享
    .card-logo(v-if="!singlePayAmount")
    .card-info
      .card-info-line
        .card-info-line-one
          span {{moduleInfo.rideCardInfoDTO.businessId === 1?'单车':'助力车'}}
          span {{getValue()}}
        .card-info-line-two {{ getTags(moduleInfo) }}
      .ride-num
        span.normal 剩
        span.weight(
        ) {{getValue().includes('不限次卡') ? moduleInfo.rideCardInfoDTO.remainDays : moduleInfo.rideCardInfoDTO.useProperty.remainCardTimes}}
        span.unit() {{getValue().includes('不限次卡') ? '天' : '次'}}
  .upgrade-container(v-if="isUpgrade && !moduleInfo.upgradeImg" @click="buyUpgrade")
    .left
      img(src="https://m.hellobike.com/resource/gallery/407/A0LCi7HL_image%2052.png")
      span 升级成为超级会员，享超值权益
    .right {{ moduleInfo.signInfoDTO.firstSignPrice || ''}}元升级
  .upgrade-v2-container(v-else-if="isUpgrade && moduleInfo.upgradeImg" @click="buyUpgrade")
    img.upgrade-v2-img(:src="moduleInfo.upgradeImg")
</template>
<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getNoScroll, safeGet } from '@/utils';
import { ParamsUtil } from '@/utils/params';

export default {
  props: {
    moduleData: {
      type: Object,
      default() {
        return {};
      },
    },
    // 是否展示升级按钮
    isUpgrade: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      moduleInfo: {},
      singlePayAmount: 0,
      isApp: false,
      isCardUpdate: false,
    };
  },
  watch: {
    moduleData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.moduleInfo = val;
        this.singlePayAmount = safeGet(this.moduleInfo, 'rideCardInfoDTO.deductRule.payAmount', 0);
        const { isCardUpdate } = ParamsUtil.getParams(window.location.href);
        this.isCardUpdate = isCardUpdate === 'true';
        if (this.isCardUpdate && this.isUpgrade && Object.keys(this.moduleInfo).length > 0) {
          this.buyUpgrade();
        }
      },
    },
  },
  mounted() {
    this.moduleInfo = this.moduleData;
    this.isApp = safeGet(this.moduleInfo, 'rideCardInfoDTO.useRuleProperty.usePlatform', -1) === 0;
    if (this.isUpgrade) {
      UBT.moduleExpose({
        pageId: 'platform_savemoneycard_page',
        categoryId: 'platform',
        moduleId: 'platform_shengjiVIP',
        contentId: 'platform_shengjiVIP',
        exposureTimes: 1,
        businessInfo: {},
      });
    }
  },
  methods: {
    // 单车卡天数
    getValue() {
      if (this.moduleInfo.rideCardInfoDTO && this.moduleInfo.rideCardInfoDTO.useProperty) {
        const { totalCardDays, totalCardTimes } = this.moduleInfo.rideCardInfoDTO.useProperty;
        return `${totalCardDays}天${totalCardTimes || '不限'}次卡`;
      }
      return '';
    },
    // 单车卡剩余天数
    getDays() {
      if (this.getValue().includes('不限次卡')) {
        const remainDays = safeGet(this.moduleInfo, 'rideCardInfoDTO.remainDays', 0);
        return `剩${remainDays}天`;
      }
      const remainCardTimes = safeGet(this.moduleInfo, 'rideCardInfoDTO.useProperty.remainCardTimes', 0);
      return `剩${remainCardTimes}次`;
    },
    // 单车卡描述
    getTags(packageData) {
      if (packageData && packageData.rideCardInfoDTO) {
        const { rideFreeMinute, rideFreeCost, payAmount } = packageData.rideCardInfoDTO.deductRule;
        if (this.singlePayAmount > 0) {
          return `生效中 | 前${rideFreeMinute}分钟仅${payAmount}元`;
        }
        if (rideFreeMinute || rideFreeCost) {
          if (packageData.rideCardInfoDTO.businessId === 1) {
            return `生效中 | 单笔抵${rideFreeMinute}分钟`;
          }
          return `生效中 | 单笔抵${rideFreeCost}元`;
        }
      }
      return '生效中';
    },
    // 升级处理
    buyUpgrade() {
      this.$emit('buyUpgrade', this.moduleInfo);
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_shengjiVIP',
        categoryId: 'platform',
        businessInfo: {},
      });
      getNoScroll(true);
    },
  },
};
</script>
<style lang="less" scoped>
.my-card-template {
  position: relative;
  font-family: PingFang SC, sans-serif;

  .my-card-container {
    position: relative;
    height: 0.72rem;
    border-radius: 0.1rem;
    display: flex;
    align-items: center;
    background: linear-gradient(to right, #3bf 0%, #33a0ff 100%);
    color: #fff;
    z-index: 2;

    &.one-cent-ride {
      background-image: url('https://m.hellobike.com/c618f2e6a7.png');
      background-size: 100% 100%;
      padding-left: 0.2rem;
    }

    .card-logo {
      width: 0.53rem;
      height: 0.42rem;
      margin-right: 0.1rem;
      background: url('https://m.hellobike.com/resource/gallery/407/xc3enRCeki.png') no-repeat;
      background-size: 100% 100%;
    }

    .card-info {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .card-info-line {
        .card-info-line-one {
          font-size: 0.15rem;
          font-weight: 500;
        }

        .card-info-line-two {
          font-size: 0.12rem;
          font-weight: 400;
          margin-top: 0.02rem;
          opacity: 0.7;
        }
      }

      .ride-num {
        margin-right: 0.31rem;
        font-size: 0.15rem;
        font-weight: 500;
        font-family: "DIN Alternate Bold", sans-serif;

        .weight {
          font-size: 0.22rem;
          margin-left: 0.02rem;
          margin-right: 0.02rem;
        }

        .unit {
          font-size: 0.15rem;
        }
      }
    }
  }

  .upgrade-container {
    margin-top: -0.27rem;
    width: 3.35rem;
    height: 0.65rem;
    border-radius: 0.12rem;
    background: url('https://m.hellobike.com/resource/gallery/407/bvbNL6_T_Rectangle%203472805.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0 0.08rem 0.08rem 0;

    .left {
      color: #8c4c00;
      font-size: 0.12rem;
      font-weight: 400;
      display: flex;
      align-items: center;

      img {
        width: 0.2rem;
        height: 0.2rem;
      }
    }

    .right {
      width: 0.69rem;
      height: 0.22rem;
      flex-shrink: 0;
      border-radius: 0.11rem;
      background: #ffdd7e;
      color: var(--grey-10, #242729);
      text-align: center;
      line-height: 0.22rem;
      font-size: 0.11rem;
      font-weight: 500;
    }
  }

  .upgrade-v2-container {
    margin-top: -0.22rem;

    .upgrade-v2-img {
      object-fit: contain;
      width: 100%;
    }
  }

  .app-use-logo {
    position: absolute;
    right: 0;
    top: 0;
    width: 0.51rem;
    height: 0.17rem;
    background: linear-gradient(90deg, #fff5e2 0%, #ffcab7 100%);
    border: 0.005rem solid #fff;
    border-radius: 0 0.1rem 0 0.1rem;
    z-index: 2;

    .app-use-logo-text {
      font-size: 0.1rem;
      color: #000;
      line-height: 0.17rem;
      text-align: center;
      font-weight: 600;
    }
  }
}
</style>
